import script from "./DeviceItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceItemModal.vue?vue&type=script&setup=true&lang=js"

import "./DeviceItemModal.vue?vue&type=style&index=0&id=06fb99be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fb99be"]])

export default __exports__